module.exports = __webpack_public_path__ + "media/images/lb/571-ec57fe084a1a183c3abe2ded01e16356.svg";